/** Hosts (a host or any of its subdomains) and the app each belongs to. */
const HOSTS = [
    ['asana.com', 'asana'],
    ['outlook.office.com', 'outlook'], ['outlook.office365.com', 'outlook'], ['outlook.live.com', 'outlook'], ['outlook.cloud.microsoft', 'outlook'],
    ['dropbox.com', 'dropbox'], ['dropboxusercontent.com', 'dropbox'],
    ['teams.microsoft.com', 'teams'], ['teams.cloud.microsoft', 'teams'], ['teams.live.com', 'teams'],
    ['procore.com', 'procore'],
    ['bluebeam.com', 'bluebeam'],
];
/**
 * Words in a detail line's first segment and the app they name. A Revit element has no web address, so its card is known
 * by its detail line ("Gyro AI for Revit · Northgate_MOB_Arch.rvt"); the Revit words may stand anywhere in that segment.
 */
const DETAIL_WORDS = [
    [/^asana\b/i, 'asana'],
    [/^(?:outlook )?calendar\b/i, 'calendar'],
    [/^outlook\b|^e-?mail\b|^mail\b/i, 'outlook'],
    [/^dropbox\b/i, 'dropbox'],
    [/revit\b/i, 'revit'],
    [/^(?:microsoft )?teams\b/i, 'teams'],
    [/^procore\b/i, 'procore'],
    [/^bluebeam\b|^revu\b/i, 'bluebeam'],
];
/** `text` split at each ` · ` or ` — ` (a middle dot or em dash with white space on both sides), each part trimmed; one pass. */
export function dotSegments(text) {
    const parts = [];
    let start = 0;
    for (let i = 1; i + 1 < text.length; i++) {
        const char = text[i];
        if ((char === '·' || char === '—') && /\s/.test(text[i - 1]) && /\s/.test(text[i + 1])) {
            parts.push(text.slice(start, i).trim());
            start = i + 1;
        }
    }
    parts.push(text.slice(start).trim());
    return parts.filter(Boolean);
}
function hostApp(href) {
    let url;
    try {
        url = new URL(href);
    }
    catch {
        return null;
    }
    if (url.protocol === 'mailto:')
        return 'outlook';
    const host = url.hostname.toLowerCase();
    const match = HOSTS.find(([name]) => host === name || host.endsWith(`.${name}`));
    if (!match)
        return null;
    // A calendar item: the path names the calendar (new Outlook), or Outlook on the web's `path` query does (an event's webLink).
    if (match[1] === 'outlook' && (/^\/(?:[^/]+\/)?calendar\b/i.test(url.pathname) || /^\/calendar\b/i.test(url.searchParams.get('path') ?? '')))
        return 'calendar';
    return match[1];
}
/** The app a card belongs to: with an address, by its host alone (else generic); without one, by its detail line's first segment. */
export function linkCardApp(href, detail) {
    if (href)
        return hostApp(href) ?? 'generic';
    const first = dotSegments(detail ?? '')[0] ?? '';
    return DETAIL_WORDS.find(([words]) => words.test(first))?.[1] ?? 'generic';
}
//# sourceMappingURL=linkCardApps.js.map